"use strict";
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var OptimizationGoalsSettings_1 = require("../../general-settings/model/optimalization-goal/OptimizationGoalsSettings");

var RealImpactValueConverter_1 = require("../../impact/conversions/RealImpactValueConverter");

var CompanyVsCRPChangeIndexConverter_1 = require("../../price-calculation/conversions/CompanyVsCRPChangeIndexConverter");

var CompetitorReferentialPriceConverter_1 = require("../../price-calculation/conversions/CompetitorReferentialPriceConverter");

var ReferencePriceConverter_1 = require("../../price-calculation/conversions/ReferencePriceConverter");

var ExportedPriceHistoryConverter_1 = require("../../price-list/conversions/ExportedPriceHistoryConverter");

var PriceStatsConverter_1 = require("../../price-list/conversions/PriceStatsConverter");

var PriceChangeIndexConverter_1 = require("../../product/conversions/PriceChangeIndexConverter");

var ProductPriceConverter_1 = require("../../product/conversions/ProductPriceConverter");

var RegularProductPriceConverter_1 = require("../../product/conversions/RegularProductPriceConverter");

var PriceZoneReleasePrices_1 = require("../model/PriceZoneReleasePrices");

var FinalProductPriceConverter_1 = require("./FinalProductPriceConverter");

var OptimalPriceConverter_1 = require("./OptimalPriceConverter");

var PriceCommentConverter_1 = require("./PriceCommentConverter");

var PriceZoneReleasePricesConverter_1 = require("./PriceZoneReleasePricesConverter");

var ReleaseItemRepricingConverter_1 = require("./ReleaseItemRepricingConverter");
/**
 * Default implementation of price zone release prices converter.
 *
 * @author Radek Beran
 */


var PriceZoneReleasePricesConverterImpl =
/*#__PURE__*/
function (_PriceZoneReleasePric) {
  _inherits(PriceZoneReleasePricesConverterImpl, _PriceZoneReleasePric);

  function PriceZoneReleasePricesConverterImpl(productPriceConverter, regularProductPriceConverter, referencePriceConverter, optimalPriceConverter, finalProductPriceConverter, competitorReferentialPriceConverter, priceCommentConverter, repricingConverter, priceChangeIndexConverter, priceStatsConverter, realImpactValueConverter, companyVsCRPChangeIndexConverter, exportedPriceHistoryConverter) {
    var _this;

    _classCallCheck(this, PriceZoneReleasePricesConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneReleasePricesConverterImpl).call(this));
    _this.productPriceConverter = productPriceConverter;
    _this.regularProductPriceConverter = regularProductPriceConverter;
    _this.referencePriceConverter = referencePriceConverter;
    _this.optimalPriceConverter = optimalPriceConverter;
    _this.finalProductPriceConverter = finalProductPriceConverter;
    _this.competitorReferentialPriceConverter = competitorReferentialPriceConverter;
    _this.priceCommentConverter = priceCommentConverter;
    _this.repricingConverter = repricingConverter;
    _this.priceChangeIndexConverter = priceChangeIndexConverter;
    _this.priceStatsConverter = priceStatsConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.companyVsCRPChangeIndexConverter = companyVsCRPChangeIndexConverter;
    _this.exportedPriceHistoryConverter = exportedPriceHistoryConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceZoneReleasePricesConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new PriceZoneReleasePrices_1.PriceZoneReleasePrices(PriceZoneReleasePrices_1.PriceZoneReleasePrices.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), conversions.asObjectOpt(source, 'competitorReferencePrice', function (doc) {
        return _this2.competitorReferentialPriceConverter.toObject(doc, conversions);
      }), utils_1.Utils.isValueMissing(source.competitorReferencePrices) ? immutable_1.List() : conversions.asObjectList(source, 'competitorReferencePrices', function (doc) {
        return _this2.competitorReferentialPriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'referencePriceOld', function (doc) {
        return _this2.referencePriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'referencePrice', function (doc) {
        return _this2.referencePriceConverter.toObject(doc, conversions);
      }), !utils_1.Utils.isValueMissing(source.referencePriceChangeIndexPercent) ? PriceZoneReleasePrices_1.PriceZoneReleasePrices.schema.referencePriceChangeIndexPercent.valueOf(this.priceChangeIndexConverter.toObject(source.referencePriceChangeIndexPercent, conversions)) : null, conversions.asObjectOpt(source, 'optimalPriceWithConstraints', function (doc) {
        return _this2.optimalPriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'optimalPriceWithoutConstraints', function (doc) {
        return _this2.optimalPriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'edlpPrice', function (doc) {
        return _this2.productPriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'regularPrice', function (doc) {
        return _this2.regularProductPriceConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'regularPriceChangeIndexPercent', function (doc) {
        return _this2.priceChangeIndexConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'regularPriceChangeWeightedIndexPercent', function (doc) {
        return _this2.priceChangeIndexConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'companyVsReferencePriceChangeIndexPercent', function (doc) {
        return _this2.priceChangeIndexConverter.toObject(doc, conversions);
      }), utils_1.Utils.isValueMissing(source.companyVsCRPChangeIndices) ? immutable_1.List() : conversions.asObjectList(source, 'companyVsCRPChangeIndices', function (doc) {
        return _this2.companyVsCRPChangeIndexConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'promoPriceStats', function (doc) {
        return _this2.priceStatsConverter.toObject(doc, conversions);
      }), source.marginOldUnit && '' !== source.marginOldUnit ? conversions.toBigNumber(source.marginOldUnit) : null, source.marginOld && '' !== source.marginOld ? conversions.toBigNumber(source.marginOld) : null, source.marginOldPercent && '' !== source.marginOldPercent ? conversions.toBigNumber(source.marginOldPercent) : null, source.marginNewUnit && '' !== source.marginNewUnit ? conversions.toBigNumber(source.marginNewUnit) : null, source.marginNew && '' !== source.marginNew ? conversions.toBigNumber(source.marginNew) : null, source.marginNewPercent && '' !== source.marginNewPercent ? conversions.toBigNumber(source.marginNewPercent) : null, source.marginImpact && '' !== source.marginImpact ? conversions.toBigNumber(source.marginImpact) : null, source.marginImpactPercent && '' !== source.marginImpactPercent ? conversions.toBigNumber(source.marginImpactPercent) : null, source.salesVolumeOld && '' !== source.salesVolumeOld ? conversions.toBigNumber(source.salesVolumeOld) : null, source.salesVolumeNew && '' !== source.salesVolumeNew ? conversions.toBigNumber(source.salesVolumeNew) : null, source.salesVolumeImpact && '' !== source.salesVolumeImpact ? conversions.toBigNumber(source.salesVolumeImpact) : null, source.revenueOld && '' !== source.revenueOld ? conversions.toBigNumber(source.revenueOld) : null, source.revenueNew && '' !== source.revenueNew ? conversions.toBigNumber(source.revenueNew) : null, source.revenueImpact && '' !== source.revenueImpact ? conversions.toBigNumber(source.revenueImpact) : null, source.revenueImpactPercent && '' !== source.revenueImpactPercent ? conversions.toBigNumber(source.revenueImpactPercent) : null, source.profitOldUnit && '' !== source.profitOldUnit ? conversions.toBigNumber(source.profitOldUnit) : null, source.profitOld && '' !== source.profitOld ? conversions.toBigNumber(source.profitOld) : null, source.profitOldPercent && '' !== source.profitOldPercent ? conversions.toBigNumber(source.profitOldPercent) : null, source.profitNewUnit && '' !== source.profitNewUnit ? conversions.toBigNumber(source.profitNewUnit) : null, source.profitNew && '' !== source.profitNew ? conversions.toBigNumber(source.profitNew) : null, source.profitNewPercent && '' !== source.profitNewPercent ? conversions.toBigNumber(source.profitNewPercent) : null, source.profitImpact && '' !== source.profitImpact ? conversions.toBigNumber(source.profitImpact) : null, source.profitImpactPercent && '' !== source.profitImpactPercent ? conversions.toBigNumber(source.profitImpactPercent) : null, source.priceElasticity && '' !== source.priceElasticity ? conversions.toBigNumber(source.priceElasticity) : null, conversions.asEnumOpt(source.optimizationGoal, OptimizationGoalsSettings_1.OptimizationGoal), conversions.asObjectOpt(source, 'finalPrice', function (doc) {
        return _this2.finalProductPriceConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'exportedPriceHistory', function (doc) {
        return _this2.exportedPriceHistoryConverter.toObject(doc, conversions);
      }), !utils_1.Utils.isValueMissing(source.priceCode) && '' !== source.priceCode ? PriceZoneReleasePrices_1.PriceZoneReleasePrices.schema.priceCode.valueOfField(source) : null, conversions.asObject(source, 'repricing', function (doc) {
        return _this2.repricingConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'comments', function (doc) {
        return _this2.priceCommentConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'realImpact', function (doc) {
        return _this2.realImpactValueConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId)
      }); // FIXME do not repeat Object.assign each time

      Object.assign(result, {
        competitorReferencePrice: source.competitorReferencePrice !== null ? this.competitorReferentialPriceConverter.toDocument(source.competitorReferencePrice, conversions) : null
      });
      Object.assign(result, {
        competitorReferencePrices: conversions.asObjectArray(source, 'competitorReferencePrices', function (field) {
          return _this3.competitorReferentialPriceConverter.toDocument(field, conversions);
        })
      });
      Object.assign(result, {
        referencePriceOld: source.referencePriceOld !== null ? this.referencePriceConverter.toDocument(source.referencePriceOld, conversions) : null
      });
      Object.assign(result, {
        referencePrice: source.referencePrice !== null ? this.referencePriceConverter.toDocument(source.referencePrice, conversions) : null
      });
      Object.assign(result, {
        referencePriceChangeIndexPercent: source.referencePriceChangeIndexPercent !== null ? this.priceChangeIndexConverter.toDocument(source.referencePriceChangeIndexPercent, conversions) : null
      });
      Object.assign(result, {
        optimalPriceWithConstraints: source.optimalPriceWithConstraints !== null ? this.optimalPriceConverter.toDocument(source.optimalPriceWithConstraints, conversions) : null
      });
      Object.assign(result, {
        optimalPriceWithoutConstraints: source.optimalPriceWithoutConstraints !== null ? this.optimalPriceConverter.toDocument(source.optimalPriceWithoutConstraints, conversions) : null
      });
      Object.assign(result, {
        edlpPrice: source.edlpPrice !== null ? this.productPriceConverter.toDocument(source.edlpPrice, conversions) : null
      });
      Object.assign(result, {
        regularPrice: source.regularPrice !== null ? this.regularProductPriceConverter.toDocument(source.regularPrice, conversions) : null
      });
      Object.assign(result, {
        regularPriceChangeIndexPercent: source.regularPriceChangeIndexPercent !== null ? this.priceChangeIndexConverter.toDocument(source.regularPriceChangeIndexPercent, conversions) : null
      });
      Object.assign(result, {
        regularPriceChangeWeightedIndexPercent: source.regularPriceChangeWeightedIndexPercent !== null ? this.priceChangeIndexConverter.toDocument(source.regularPriceChangeWeightedIndexPercent, conversions) : null
      });
      Object.assign(result, {
        companyVsReferencePriceChangeIndexPercent: source.companyVsReferencePriceChangeIndexPercent !== null ? this.priceChangeIndexConverter.toDocument(source.companyVsReferencePriceChangeIndexPercent, conversions) : null
      });
      Object.assign(result, {
        companyVsCRPChangeIndices: conversions.asObjectArray(source, 'companyVsCRPChangeIndices', function (field) {
          return _this3.companyVsCRPChangeIndexConverter.toDocument(field, conversions);
        })
      });
      Object.assign(result, {
        promoPriceStats: this.priceStatsConverter.toDocument(source.promoPriceStats, conversions)
      });
      Object.assign(result, {
        marginOldUnit: source.marginOldUnit !== null ? conversions.fromBigNumber(source.marginOldUnit) : null,
        marginOld: source.marginOld !== null ? conversions.fromBigNumber(source.marginOld) : null
      });
      Object.assign(result, {
        marginOldPercent: source.marginOldPercent !== null ? conversions.fromBigNumber(source.marginOldPercent) : null
      });
      Object.assign(result, {
        marginNewUnit: source.marginNewUnit !== null ? conversions.fromBigNumber(source.marginNewUnit) : null,
        marginNew: source.marginNew !== null ? conversions.fromBigNumber(source.marginNew) : null
      });
      Object.assign(result, {
        marginNewPercent: source.marginNewPercent !== null ? conversions.fromBigNumber(source.marginNewPercent) : null
      });
      Object.assign(result, {
        marginImpact: source.marginImpact !== null ? conversions.fromBigNumber(source.marginImpact) : null
      });
      Object.assign(result, {
        marginImpactPercent: source.marginImpactPercent !== null ? conversions.fromBigNumber(source.marginImpactPercent) : null
      });
      Object.assign(result, {
        salesVolumeOld: source.salesVolumeOld !== null ? conversions.fromBigNumber(source.salesVolumeOld) : null
      });
      Object.assign(result, {
        salesVolumeNew: source.salesVolumeNew !== null ? conversions.fromBigNumber(source.salesVolumeNew) : null
      });
      Object.assign(result, {
        salesVolumeImpact: source.salesVolumeImpact !== null ? conversions.fromBigNumber(source.salesVolumeImpact) : null
      });
      Object.assign(result, {
        revenueOld: source.revenueOld !== null ? conversions.fromBigNumber(source.revenueOld) : null
      });
      Object.assign(result, {
        revenueNew: source.revenueNew !== null ? conversions.fromBigNumber(source.revenueNew) : null
      });
      Object.assign(result, {
        revenueImpact: source.revenueImpact !== null ? conversions.fromBigNumber(source.revenueImpact) : null
      });
      Object.assign(result, {
        revenueImpactPercent: source.revenueImpactPercent !== null ? conversions.fromBigNumber(source.revenueImpactPercent) : null
      });
      Object.assign(result, {
        profitOldUnit: source.profitOldUnit !== null ? conversions.fromBigNumber(source.profitOldUnit) : null,
        profitOld: source.profitOld !== null ? conversions.fromBigNumber(source.profitOld) : null
      });
      Object.assign(result, {
        profitOldPercent: source.profitOldPercent !== null ? conversions.fromBigNumber(source.profitOldPercent) : null
      });
      Object.assign(result, {
        profitNewUnit: source.profitNewUnit !== null ? conversions.fromBigNumber(source.profitNewUnit) : null,
        profitNew: source.profitNew !== null ? conversions.fromBigNumber(source.profitNew) : null
      });
      Object.assign(result, {
        profitNewPercent: source.profitNewPercent !== null ? conversions.fromBigNumber(source.profitNewPercent) : null
      });
      Object.assign(result, {
        profitImpact: source.profitImpact !== null ? conversions.fromBigNumber(source.profitImpact) : null
      });
      Object.assign(result, {
        profitImpactPercent: source.profitImpactPercent !== null ? conversions.fromBigNumber(source.profitImpactPercent) : null
      });
      Object.assign(result, {
        priceElasticity: source.priceElasticity !== null ? conversions.fromBigNumber(source.priceElasticity) : null
      });
      Object.assign(result, {
        optimizationGoal: source.optimizationGoal !== null ? source.optimizationGoal.toString() : null
      });
      Object.assign(result, {
        finalPrice: source.finalPrice !== null ? this.finalProductPriceConverter.toDocument(source.finalPrice, conversions) : null,
        exportedPriceHistory: this.exportedPriceHistoryConverter.toDocument(source.exportedPriceHistory, conversions)
      });
      Object.assign(result, {
        priceCode: source.priceCode
      });
      Object.assign(result, {
        repricing: conversions.asObject(source, 'repricing', function (value) {
          return _this3.repricingConverter.toDocument(value, conversions);
        })
      });
      Object.assign(result, {
        comments: conversions.asObjectArray(source, 'comments', function (field) {
          return _this3.priceCommentConverter.toDocument(field, conversions);
        })
      });

      if (source.realImpact) {
        Object.assign(result, {
          realImpact: this.realImpactValueConverter.toDocument(source.realImpact, conversions)
        });
      }

      return result;
    }
  }]);

  return PriceZoneReleasePricesConverterImpl;
}(PriceZoneReleasePricesConverter_1.PriceZoneReleasePricesConverter);

PriceZoneReleasePricesConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __param(5, typescript_ioc_1.Inject), __param(6, typescript_ioc_1.Inject), __param(7, typescript_ioc_1.Inject), __param(8, typescript_ioc_1.Inject), __param(9, typescript_ioc_1.Inject), __param(10, typescript_ioc_1.Inject), __param(11, typescript_ioc_1.Inject), __param(12, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductPriceConverter_1.ProductPriceConverter, RegularProductPriceConverter_1.RegularProductPriceConverter, ReferencePriceConverter_1.ReferencePriceConverter, OptimalPriceConverter_1.OptimalPriceConverter, FinalProductPriceConverter_1.FinalProductPriceConverter, CompetitorReferentialPriceConverter_1.CompetitorReferentialPriceConverter, PriceCommentConverter_1.PriceCommentConverter, ReleaseItemRepricingConverter_1.ReleaseItemRepricingConverter, PriceChangeIndexConverter_1.PriceChangeIndexConverter, PriceStatsConverter_1.PriceStatsConverter, RealImpactValueConverter_1.RealImpactValueConverter, CompanyVsCRPChangeIndexConverter_1.CompanyVsCRPChangeIndexConverter, ExportedPriceHistoryConverter_1.ExportedPriceHistoryConverter])], PriceZoneReleasePricesConverterImpl);
exports.PriceZoneReleasePricesConverterImpl = PriceZoneReleasePricesConverterImpl;